import { Injectable } from '@angular/core';
import { HttpEvent, HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { LoaderHandlerService } from 'src/app/shared/services/loader-handler.service';
import { ToastrService } from 'ngx-toastr';
const pluck = (key: string) => (array: Array<Record<string, any>>) => Array.from(new Set(array.map((obj) => obj[key])));


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};


@Injectable({
  providedIn: 'root'
})

export class NetworkService {
  private unauthorizedErrorShown = false;

  constructor(
    private http: HttpClient,
    private loaderHandler: LoaderHandlerService,
    private env: EnvironmentService,
    private toastr: ToastrService
  ) { }

  setHeaders(isFile: any, data?: any) {
    if (!isFile) {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
         // 'Ocp-Apim-Subscription-Key': this.env.getSubscriptionKey()
        })
      };
    }
    return {
      headers: new HttpHeaders({
        Accept: 'application/json',
       // 'Ocp-Apim-Subscription-Key': this.env.getSubscriptionKey(),
        'enctype': 'multipart/form-data'
      }),
      body: data ? data : undefined,
    };
  }

  httpReq(reqType: string, baseURL: string, endURL: string, data?: any, isFile = false, loaderNeeded = true): Observable<any> {
    const fullURL = this.env.getAPIBaseURL(baseURL) + endURL;
    if (loaderNeeded) {
      this.loaderHandler.toggleLoader(1);
    }

    switch (reqType) {
      case 'get':
        const encodedURL = this.encodeURL(fullURL, data);
        return this.http.get(encodedURL, this.setHeaders(isFile)).pipe(
          tap(res => this.handleHTTPSuccess(res)),
          catchError(this.handleError('error', []))
        );

      case 'post':
        return this.http.post(fullURL, data, this.setHeaders(isFile)).pipe(
          tap(res => this.handleHTTPSuccess(res)),
          catchError(this.handleError('error', []))
        );

      case 'put':
        return this.http.put(fullURL, data, this.setHeaders(isFile)).pipe(
          tap(res => this.handleHTTPSuccess(res)),
          catchError(this.handleError('error', []))
        );

      case 'delete':
        const encodeURL = isFile ? fullURL : this.encodeURL(fullURL, data);
        return this.http.delete(encodeURL, this.setHeaders(isFile, data)).pipe(
          tap(res => this.handleHTTPSuccess(res)),
          catchError(this.handleError('error', []))
        );
      case 'getBlob':
        const encodedBlobURL = this.encodeURL(fullURL, data);
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json');
       // headers = headers.set('Ocp-Apim-Subscription-Key', this.env.getSubscriptionKey());
        return this.http.get(encodedBlobURL, { headers, responseType: 'blob' }).pipe(
          tap(res => this.handleHTTPSuccess(res)),
          catchError(this.handleError('error', []))
        );
    }

    return throwError(() => new Error(`Unsupported request type: ${reqType}`));
  }

  handleError<T>(operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {
      // const urlHead = error.url.split('/')[2];
      // let errMsg = urlHead.includes('dfos') ? 'DFOS Request Failure' : 'Request Failure';
      let errMsg = 'Request Failure';
      let filePath: string | null = null;
      const errorUrl = error?.url ?? '';
      if (error && !errorUrl.includes('insertusage')) {
        if (error.status === 401) {
          if (!this.unauthorizedErrorShown) {
            this.unauthorizedErrorShown = true;
            this.showError('Unauthorized Access');
          }
          this.loaderHandler.toggleLoader(0);
          return EMPTY;
        } else {
          if (error && error.error) {
            errMsg = error.error.errorMessage || error.error.message || error.error.title;
            if (error.error.filePath) {
              filePath = error.error.filePath;
            }
          }
          this.showError(errMsg);
          return throwError(() => filePath);
        }
        return of(result as T);
      }

      return of(result as T);
    };
  }

  handleHTTPSuccess<T>(result: T): T {
    this.unauthorizedErrorShown = false;
    this.loaderHandler.toggleLoader(0);
    return result;
  }

  showError(errorMsg: string) {
    this.toastr.error(errorMsg, 'Error');
    this.loaderHandler.toggleLoader(0);
    setTimeout(() => {
      const el = document.getElementById('toast-container') as any;
      if (!el) { return; }
      if (!el.hasAttribute('popover')) {
        el.setAttribute('popover', 'manual');
      }
      try { el.hidePopover?.(); } catch { }
      try { el.showPopover?.(); } catch { }
    });
  }

  encodeURL(url: string, data?: Record<string, any>) {
    let encodedUrl = url;
    if (data) {
      encodedUrl = encodedUrl + '?' +
        Object.keys(data).map((k) => {
          return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]);
        }).join('&');
    }
    return encodedUrl;
  }

  getPermissions(role: any = 'no-role') {
    if (!role) {
      role = 'no-role';
    }
    const splits = role.toLowerCase().split(' ');
    const fileName = splits.join('-') + '.json';
    const fullURL = this.env.getAPIBaseURL('masterConfig') + 'masterconfigs/roles/SPC';
    return this.http.get('/assets/permissions/' + fileName).
      pipe(
        map((data: any) => data.accessRights),
        map((data: any) => data.filter((item: any) => item.isPresent)),
        map((data: any) => this.processPermission(data))
      );
  }
  processPermission(data: any): any {
    const perms = pluck('name');
    return perms(data);
  }
}
